import { STATUS } from './constants'

// Formatters, status helpers and the status text-colour map live in the shared
// KpiCard module so Statistics and Evolution metric cards stay in sync.
export {
  alertStatus, formatInteger, formatNumber, formatPercent,
  gradeStatus, satisfactionStatus, STATUS_TEXT_CLASS
} from '../ui/KpiCard/status'

const STATUS_HEX = {
  [STATUS.GREEN]: '#2cc675',
  [STATUS.ORANGE]: '#ec8e00',
  [STATUS.RED]: '#b80000',
  [STATUS.NEUTRAL]: '#d1d5db'
}

const lerpHex = (from, to, ratio) => {
  const channels = [1, 3, 5].map(offset => {
    const fromChannel = parseInt(from.slice(offset, offset + 2), 16)
    const toChannel = parseInt(to.slice(offset, offset + 2), 16)
    return Math.round(fromChannel + (toChannel - fromChannel) * ratio).toString(16).padStart(2, '0')
  })
  return `#${channels.join('')}`
}

// Continuous red → orange → green gradient driven by ratio ∈ [0, 1].
// Two-segment interpolation through the DS anchors so the path matches the
// Gauge.js legacy (`_global_overview_grades.html.haml`) without pulling chroma.
export const interpolateGaugeColor = ratio => {
  if (!Number.isFinite(ratio))
    return STATUS_HEX[STATUS.NEUTRAL]
  const clamped = Math.max(0, Math.min(1, ratio))
  if (clamped < 0.5)
    return lerpHex(STATUS_HEX[STATUS.RED], STATUS_HEX[STATUS.ORANGE], clamped * 2)
  return lerpHex(STATUS_HEX[STATUS.ORANGE], STATUS_HEX[STATUS.GREEN], (clamped - 0.5) * 2)
}
